import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, FileText } from "lucide-react";
import MarketingNav from "../../components/MarketingNav";
import Chip from "../../components/atoms/Chip";
import { TEMPLATES } from "./TemplatePage";

export default function TemplateIndex() {
  useEffect(() => {
    document.title = "Communication Templates — SpeakEasy";
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Professional email and communication templates for office, interview, and HR situations. Leave request, follow-up, salary negotiation, apology — written and ready to adapt.";
  }, []);

  const entries = Object.entries(TEMPLATES);

  return (
    <div style={{ background: "var(--paper)", minHeight: "100vh" }}>
      <MarketingNav />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" style={{ padding: "64px 24px 80px" }}>
        <Chip tone="gold">Templates</Chip>
        <h1 className="font-display" style={{ fontSize: "clamp(44px, 6vw, 64px)", lineHeight: 1.02, letterSpacing: "-0.025em", margin: "16px 0 16px", fontWeight: 400, maxWidth: "20ch" }}>
          Email templates <em style={{ color: "var(--gold-500)" }}>that read like a person wrote them.</em>
        </h1>
        <p style={{ fontSize: 18, color: "var(--fg-2)", lineHeight: 1.6, margin: "0 0 40px", maxWidth: "62ch" }}>
          Leave requests, HR follow-ups, salary negotiation, client apologies, interview introductions. Copy what fits, change the names, send.
        </p>

        <div className="grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16 }}>
          {entries.map(([slug, t]) => (
            <Link key={slug} to={`/templates/${slug}`} style={{ textDecoration: "none", color: "inherit", display: "block" }}>
              <article style={{
                padding: "22px 22px 20px",
                background: "#fff",
                border: "1px solid var(--border-1)",
                borderTop: "3px solid var(--gold-500)",
                borderRadius: "var(--radius-lg)",
                transition: "transform 200ms cubic-bezier(.2,.8,.2,1), box-shadow 200ms cubic-bezier(.2,.8,.2,1)",
                cursor: "pointer",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 10,
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "var(--shadow-card)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}>
                <div style={{ width: 40, height: 40, borderRadius: "var(--radius-md)", background: "rgba(200,154,44,.18)", color: "var(--gold-600)", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                  <FileText size={20} strokeWidth={1.6} />
                </div>
                <h3 className="font-display" style={{ fontSize: 24, lineHeight: 1.1, fontWeight: 400, margin: "4px 0 0", letterSpacing: "-0.01em" }}>
                  {t.title}
                </h3>
                <p style={{ color: "var(--fg-2)", fontSize: 14, lineHeight: 1.5, margin: 0, flex: 1 }}>
                  {t.meta}
                </p>
                <div style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "var(--gold-700)", fontSize: 13, fontWeight: 600, marginTop: 4 }}>
                  Read <ArrowRight size={13} strokeWidth={2} />
                </div>
              </article>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
